import React from 'react'
import './Vision.css'
import visionlogo from '../Home/images/Pt. L.R.College of Technology (2).JPG'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faBullseye} from '@fortawesome/free-solid-svg-icons'


const Vision_Mission = () => {
  return (
    <div className='main-container-vision'>
      <div className='logo-container'>
        <div className='logo-container-image'>
        <div data-aos="fade-right"
         data-aos-duration="3000">

          <img src={visionlogo} className='image-logo-vision' alt="Vision Logo" />
          </div>
          <div className='vision-box'>
          <div data-aos="fade-up"
         data-aos-duration="2000">
            <div className='motto'>
              <h1>
                 Our Motto
              </h1>  <br /> 
              <p>Florentissimae sub gloriam del <br /> Flourishing under the glory of God</p>

               
            </div>
            </div>
            <div data-aos="fade-up"
              data-aos-duration="2000">
            <div className='vision'>
              <h1>
                <FontAwesomeIcon icon={faEye} /> Our Vision
              </h1>  <br /> 
              <p>• To be a global centre of learning to promote professional excellence and innovation.</p> <br /> 
              <p>• To serve the local people in the global arena.</p> <br /> 
              <p>• To build the nation and society through providing integrated and trans-cultural quality education and to be the global front-runner in value education.</p> <br /> 
            </div>
             </div>

             <div data-aos="fade-up"
              data-aos-duration="2000">
            <div className='mission'>
              <h1>
                <FontAwesomeIcon icon={faBullseye} /> Our Mission
              </h1> <br /> 
              <p>• All-round personality development emphasizes physical, practical, aesthetic, moral, and intellectual development.</p>  <br /> 
              <p>• To impart knowledge & skill-based education in collaboration with industry, academia & research organizations.</p>  <br /> 
              <p>• To explore and expand the human knowledge base.</p>  <br /> 
            </div> 
            </div> 
          </div>
          <div data-aos="fade-up"
              data-aos-duration="2000">
          <div className='main-box-container-2'>
          
         
          <div className='content'> 
          <div data-aos="fade-right">
             <h3>QUALITY POLICY</h3>
            <br /><p>• To develop a pool of highly qualified and motivated faculty members, capable of providing all the necessary inputs to the students</p> <br />
            <p> • To emphasise on research and innovation through national and international collaborations.</p> <br />
            <p>• To groom the students to face future professional and social challenges.</p> <br />
            <p>• To facilitate placement assistance to students for their future career in the Central/State Govt. Departments and Multinational Companies</p>
            </div>
            </div>
      
      
          <div className='content'>
          <div data-aos="fade-left">
            <h3> STRATEGIC GOALS</h3> <br />
            <p>• To ensure student success by providing a creative and distinctive learning experience that enhances productivity and employability</p> <br />
            <p>• To promote an academic model that encourages collective learning and group efforts.</p> <br />
            <p>• To engage in inquiry aligned to national priorities</p> <br />
            <p>• To create an environment that promotes innovation and entrepreneurship</p> <br />
            <p>• To promote intellectual exchanges from across the world</p> <br />
            <p>• To develop and sustain a safe, vibrant and eco-friendly campus that values equality and diversity</p> <br />
            <p>•To promote community empowerment through service</p> <br />
            <p>• To ensure an effective and efficient organizational governance that supports operational and service excellence</p> <br />
            <p>• To operate within a sustainable financial model</p> <br />
           </div>
           </div>
           
           <div className='content'>
           <div data-aos="fade-right">
            <h3> LEARNERS ATTRIBUTES</h3> <br />
            <p>• Professional competence
            </p> <br />
            <p>• Domain knowledge, Research and ILEARnnovation skills.</p> <br />
            <p>• Communication skills</p> <br />
            <p>• Digital competence</p> <br />
            <p>• Collective efforts and leadership skills</p> <br />
            <p>•Ethical and cultural awareness</p> <br />
            <p>•Social service</p> <br />
            <p>• Lifelong learning</p> <br />
           </div>
           </div>
           <div className='content'>
           <div data-aos="fade-left">
            <h3> OUR VALUES</h3> <br />
            <p>• Quality : We continuously challenge ourselves in quest of excellence
            </p> <br />
            <p>• Diversity : We appreciate diversity of faiths, ideas and culture.</p> <br />
            <p>• Transparency : We demonstrate integrity and open-mindedness in our service and conduct</p> <br />
            <p>• Commitment : We commit ourselves to the intellectual inquiry, environment, community and the nation</p> <br />
            <p>• Respect : We discharge our responsibility with respect for all</p> <br />
            </div>
           </div></div>
          
          
          </div>
          
        </div>
        
      </div>
    </div>
    
    
  )
}

export default Vision_Mission
